export const config = {
  serverURL: "https://production.velikano.kitg.com.ua/",
  API: "https://production.velikano.kitg.com.ua/admin/api",
  imageProxy: "https://production.velikano.kitg.com.ua/public/",
};
